import { LocalStorageKey } from 'utils/common/const';
import { clearAuthorizationBase, setAuthorizationBase } from 'config/axiosBase';

export const AUTH_CHANGED_EVENT = 'hi88-auth-changed';

/** Header mở LoginModal khi cần (ví dụ bình chọn WC khi chưa đăng nhập). */
export const OPEN_LOGIN_MODAL_EVENT = 'hi88-open-login-modal';

export function requestOpenLoginModal() {
  try {
    window.dispatchEvent(new CustomEvent(OPEN_LOGIN_MODAL_EVENT));
  } catch {
    // ignore
  }
}

export function getStoredAccessToken() {
  try {
    return localStorage.getItem(LocalStorageKey.ACCESS_TOKEN);
  } catch {
    return null;
  }
}

/** Trích token từ response signin (ResponseModel hoặc biến thể). */
export function extractUserToken(res) {
  if (!res || typeof res !== 'object') return null;

  const direct =
    (typeof res.userToken === 'string' && res.userToken) ||
    (typeof res.token === 'string' && res.token) ||
    (typeof res.accessToken === 'string' && res.accessToken);
  if (direct) return direct;

  const data = res.data;
  if (data && typeof data === 'object') {
    const nested =
      (typeof data.userToken === 'string' && data.userToken) ||
      (typeof data.token === 'string' && data.token) ||
      (typeof data.accessToken === 'string' && data.accessToken);
    if (nested) return nested;
  }

  return null;
}

export function persistAuthSession(token, username) {
  if (!token) return;
  const clean = String(token).replace(/"/g, '');
  localStorage.setItem(LocalStorageKey.ACCESS_TOKEN, clean);
  try {
    setAuthorizationBase(clean);
  } catch {
    // ignore
  }
  if (username) {
    try {
      localStorage.setItem('hi88_login_username', username);
    } catch {
      // ignore
    }
  }
  try {
    window.dispatchEvent(new CustomEvent(AUTH_CHANGED_EVENT, { detail: { username } }));
  } catch {
    // ignore
  }
}

export function clearAuthSession() {
  try {
    localStorage.removeItem(LocalStorageKey.ACCESS_TOKEN);
  } catch {
    // ignore
  }
  try {
    localStorage.removeItem('hi88_login_username');
  } catch {
    // ignore
  }
  try {
    clearAuthorizationBase();
  } catch {
    // ignore
  }
  try {
    window.dispatchEvent(new CustomEvent(AUTH_CHANGED_EVENT, { detail: { username: null } }));
  } catch {
    // ignore
  }
}
